// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2LiwE","title":"InfoRow_title__3Zcsu"};